export * from './selection-list';

import { CategorySelectionListComponent } from './selection-list';

export const CategoryMolecules = [
    CategorySelectionListComponent
];